// Admin settings page. Only accessible to mapsly:admin users.

import { Link } from 'react-router-dom';
import { useAuth, isAdmin } from '../lib/auth';
import AdminConfig from '../components/AdminConfig';
import SyncButton from '../components/SyncButton';

export default function AdminPage() {
  const { user } = useAuth();

  if (!user || !isAdmin(user)) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-center">
          <h2 className="font-display text-xl font-semibold text-gray-700">Access Denied</h2>
          <p className="mt-2 text-sm text-gray-500">
            You need the mapsly:admin role to access this page.
          </p>
          <Link to="/" className="mt-4 inline-block text-sm text-brand-600 hover:underline">
            Back to map
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-gray-200 bg-white px-4 py-2">
        <div className="flex items-center gap-4">
          <Link to="/" className="font-display text-lg font-semibold text-brand-700 no-underline">
            Mapsly
          </Link>
          <span className="text-sm text-gray-400">/</span>
          <h2 className="font-display text-sm font-semibold text-gray-600">Admin</h2>
        </div>
        <SyncButton />
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-xl px-4 py-8">
          <h3 className="font-display text-lg font-semibold text-gray-800 mb-4">
            Popup Configuration
          </h3>
          <p className="text-sm text-gray-500 mb-6">
            Choose which fields appear when a map pin is clicked, and in what order.
            Changes take effect immediately.
          </p>
          <AdminConfig />
        </div>
      </div>
    </div>
  );
}
